define('errorToolTip', [
    'jquery'
], function($) {
    $(function() {
        window.$errorTooltip = $('.error_tooltip');

        $('.js-close-button').click(function() {
            if (window.$errorTooltip.length) {
                window.$errorTooltip.hide();
            }
        });
    });

    return function($from, left_side, msg, addTermsClass) {
        let er_ow;
        let from_off;

        if (typeof $from === 'undefined' || !$from.length) {
            console.error('arg `from` empty');
        }

        window.$errorTooltip.removeClass('left right terms');

        if (left_side) {
            window.$errorTooltip.addClass('right');
        } else {
            window.$errorTooltip.addClass('left');
        }

        if (addTermsClass) {
            window.$errorTooltip.addClass('terms');
        }

        window.$errorTooltip.html(msg);

        from_off = $from.offset();
        er_ow = window.$errorTooltip.outerHeight();

        if (left_side) {
            window.$errorTooltip.css({
                top: from_off.top + (($from.outerHeight() - er_ow) / 2),
                left: from_off.left - (window.$errorTooltip.outerWidth() + 10)
            });
        } else {
            window.$errorTooltip.css({
                top: from_off.top + (($from.outerHeight() - er_ow) / 2),
                left: from_off.left + $from.outerWidth() + 10
            });
        }

        window.$errorTooltip.show();
    };
});
